import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import API from "../../Network/API";
import { useTranslation } from "react-i18next";

export default function StudentTransaction() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [data, setData] = useState()
    const [loading, setLoad] = useState(false);
    useEffect(() => {
        setLoad(true)
        API.get(`/v1/oauth/student/transactions`)
            .then((response) => {
                setData(response.data.data)
                setLoad(false)
            }).catch((error) => {
                setLoad(false)
            });
    }, []);

    return (
        <>
            <div className="dashboard-title">
                <h4>{t('studentTransaction.transaction_history')}</h4>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="table-responsive custom-table">
                        <table className="table table-nowrap mb-0">
                            <thead>
                                <tr>
                                    <th>{t('studentTransaction.date')}</th>
                                    <th>{t('studentTransaction.type')}</th>
                                    <th>{t('studentTransaction.note')}</th>
                                    <th>{t('studentTransaction.amount')}</th>
                                    <th>{t('studentTransaction.fee')}</th>
                                    <th>{t('studentTransaction.total')}</th>

                                </tr>
                            </thead>
                            <tbody>

                                {
                                    loading ?
                                        <tr>
                                            <td colSpan="6" className="text-center">{t('studentTransaction.loading')}</td>
                                        </tr>
                                        : ''
                                }

                                {data?.courses?.length > 0 && data?.courses?.map((course, j) => (
                                    <tr>
                                        <td data-label={t('studentTransaction.date')}>{course.date}</td>
                                        <td data-label={t('studentTransaction.type')}>{course.type}</td>
                                        <td data-label={t('studentTransaction.note')}>{course.note}</td>
                                        <td data-label={t('studentTransaction.amount')}>{course.amount}</td>
                                        <td data-label={t('studentTransaction.fee')}>{course.fee}</td>
                                        <td data-label={t('studentTransaction.total')}>{course.total}</td>

                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}